<template>
  <div>
    <v-navigation-drawer stateless value="true" permanent expand-on-hover>
      <v-list nav dense>
        <template v-for="(item, i) in items">
          <v-list-group :key="i" :prepend-icon="item.icon" :value="item.model" color="#1976d2">
            <template v-slot:activator>
              <v-list-item-title class="list-father">{{item.text}}</v-list-item-title>
            </template>
            <v-divider :key="i + '_subdiv'" inset></v-divider>
            <template v-for="(child, j) in item.children">
              <template v-if="verificarPermiso(child.rol)">
                <v-list-item :key="j" @click="cargarContenido(child.text, item.text)">
                  <v-list-item-action>
                    <v-icon v-text="child.icon"></v-icon>
                  </v-list-item-action>
                  <v-list-item-title v-text="child.text"></v-list-item-title>
                </v-list-item>
              </template>
            </template>
          </v-list-group>
          <!--<v-divider :key="i + '_div'"></v-divider>-->
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data: () => ({
    dilog: false,
    drawer: true,
    //permisos: [],
    items: [
      {
        icon: "mdi-badge-account-horizontal",
        "icon-alt": "keyboard_arrow_down",
        text: "Administración",
        model: false,
        rol: "",
        children: [
          {
            icon: "mdi-account-tie",
            text: "Usuarios",
            rol: "1"
          },
          { icon: "mdi-school", text: "Alumnos", rol: "2" },
          { icon: "mdi-account-group", text: "Docentes", rol: "3" },
          { icon: "mdi-book-open-variant", text: "Materias", rol: "4" },
          { icon: "mdi-aspect-ratio", text: "Notas", rol: "5" },
          {
            icon: "mdi-text-box-plus-outline",
            text: "Materias Previas",
            rol: "6"
          },
          { icon: "mdi-book-open", text: "Libreta", rol: "7" },
          { icon: "mdi-share-all", text: "Promover Alumnos", rol: "8" }
        ]
      },
      {
        text: "Reportes",
        icon: "mdi-finance",
        model: false,
        rol: "",
        children: [
          { icon: "mdi-poll-box", text: "General", rol: "9" },
          { icon: "mdi-flag", text: "Aspirantes", rol: "10" },
          { icon: "mdi-file-plus", text: "Promedios", rol: "11" },
          { icon: "mdi-alert-circle", text: "Notas Criticas", rol: "12" },
          { icon: "mdi-history", text: "Historial Alumno", rol: "13" }
        ]
      },
      {
        text: "Configuracion",
        icon: "mdi-cog",
        model: false,
        rol: "3",
        children: [
          {
            icon: "mdi-view-dashboard",
            text: "Orientacion y Curricula",
            rol: "14"
          },
          {
            icon: "mdi-aspect-ratio",
            text: "Notas - Definir Edición",
            rol: "15"
          }
        ]
      }
    ]
  }),
  props: ["permiso_usuario"],
  watch: {
    visible: function() {
      this.drawer = this.visible;
    }
  },
  computed: {
    /*menuvisible: function(item) {
      //return this.verificarPermiso(item);
    }*/
  },
  mounted: function() {
    /*console.log("Mounted Menu: ");
    this.permisos = this.permiso_usuario.split(",");
    console.log("permiso_usuario: ", this.permiso_usuario);
    console.log("permiso: ", this.permisos);*/
  },

  /*beforeUpdate: function() {
    //console.log("beforeUpdate Menu: ");
    this.permisos = this.permiso_usuario.split(",");
    console.log("permiso_usuario: ", this.permiso_usuario);
    console.log("permiso: ", this.permisos);
  },*/
  methods: {
    verificarPermiso: function(permiso_menu) {
      /*if (permiso_menu == "") return false;
      else if (this.permiso_usuario <= permiso_menu) {
        return false;
      } else return true;*/
      //console.log("verificarPermiso: ", this.permiso_usuario, permiso_menu);

      if (this.permiso_usuario[0] == "total") return true;
      else {
        if (this.permiso_usuario.includes(permiso_menu)) return true;
        else return false;
      }
    },
    cargarContenido: function(valor, padre) {
      let url;
      //console.log(valor, padre);

      switch (valor) {
        case "Usuarios":
          url = "listarUsuarios";
          break;
        case "Alumnos":
          url = "listarAlumnos";
          break;
        case "Docentes":
          url = "listarDocentes";
          break;
        case "Materias":
          url = "listarMaterias";
          break;
        /* Administrativo */
        case "Promover Alumnos":
          url = "promoverAlumnos";
          break;
        case "Notas":
          url = "notasMaterias";
          break;
        case "Materias Previas":
          url = "materiasPrevias";
          break;
        case "Libreta":
          url = "libreta";
          break;
        case "Analítico":
          url = "analitico";
          break;
        /* --- Reportes --- */
        case "General":
          url = "reporteGral";
          break;
        case "Aspirantes":
          url = "reporteAbanderados";
          break;
        case "Promedios":
          url = "reportePromedios";
          break;
        case "Notas Criticas":
          url = "reporteNotasCriticas";
          break;
        case "Historial Alumno":
          url = "reporteHistorialAlumno";
          break;
        /* ----- Config ----- */
        case "Orientacion y Curricula":
          url = "curricula";
          break;
        case "Orientaciones":
          url = "orientacion";
          break;
        case "Notas - Definir Edición":
          url = "configNotas";
          break;
      }
      //console.log("url: ", url);
      this.$emit("menu:cargarContenido", url, padre);
    }
  }
};
</script>

<style>
.v-list-group {
  margin: 4px 0;
}

.v-list-group__header {
  background-color: #ddd;
  color: #1976d2 !important;
}

.v-list-group__header__prepend-icon {
  color: #1976d2 !important;
}

.list-father {
  font-weight: bold !important;
  color: #1976d2 !important;
  text-decoration: underline;
}

/*.rotar {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  -ms-filter: "FlipH";
  filter: FlipH;
}*/
</style>